module.exports = __webpack_public_path__ + "static/media/404.07f7e537.png";